export default __webpack_public_path__ + "static/accessories-min-4e075a11274c61615b69545bcd5c0bc6.jpg";